import { render } from "./CategoriesBar.vue?vue&type=template&id=6cd16618&scoped=true"
import script from "./CategoriesBar.vue?vue&type=script&lang=js"
export * from "./CategoriesBar.vue?vue&type=script&lang=js"

import "./CategoriesBar.vue?vue&type=style&index=0&id=6cd16618&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd16618"]])

export default __exports__